import { Locale } from "../Locale.js";
import { localizePathMap } from "./localizePathMap.js";

export const softwarePathMap = localizePathMap({
	[Locale.cs]: "software",
	[Locale.en]: "software",
});
